import React, { useCallback, useMemo } from 'react';
import { mapValues, values } from 'lodash';
import { useFormState } from 'react-hook-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useSelector } from 'react-redux';
import {
  FieldDataWithId,
  FormFieldsData,
  FormType
} from '../../../types/form.types';
import ContactFieldsContent from './contact-fields.content';
import useFieldsLayout from '../../../hooks/use-fields-layout.hook';
import formFieldsSelectors from '../../../store/selectors/form-fields.selectors';

interface ContactFieldsProps {
  fields: FormFieldsData;
  type: FormType;
}

const ContactFields: React.ForwardRefRenderFunction<
  ReCAPTCHA,
  ContactFieldsProps
> = ({ fields, type }, recaptchaRef) => {
  const { errors } = useFormState();
  const fetchErrorMessage = useSelector(formFieldsSelectors.getErrorMessage);

  const fieldsArray: FieldDataWithId[] = useMemo(
    () =>
      values(
        mapValues(fields, (value, key) => {
          return { id: key, ...value };
        })
      ),
    [fields]
  );
  const {
    isWhiteCase,
    renderSpacing,
    customWidth,
    requiredLegendPlaceIndex
  } = useFieldsLayout(fieldsArray, type);

  const isNumberType = useCallback(
    (id: string) => {
      return (
        (type === 'umer' && id === 'applicant_id') ||
        (type === 'partner_prospects' && id === 'number_of_branches') ||
        id === 'post_code'
      );
    },
    [type]
  );

  return (
    <ContactFieldsContent
      fieldsArray={fieldsArray}
      errors={errors}
      isWhiteCase={isWhiteCase}
      addSpacing={renderSpacing}
      customWidth={customWidth}
      requiredLegendPlaceIndex={requiredLegendPlaceIndex}
      isNumberType={isNumberType}
      ref={recaptchaRef}
      fetchErrorMessage={fetchErrorMessage}
    />
  );
};
export default React.forwardRef(ContactFields);
